"use client";
import Image from "next/image";
import logo from "@/../public/images/logo.svg";
import Link from "next/link";
import { Button } from "../common";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/20/solid";
import React, { useState } from "react";
import { NavItemProps } from "@/interfaces";

const menuItems = [
  { name: "Home", path: "/" },
  { name: "Explore", path: "/explore" },
  { name: "Rooms", path: "/rooms" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

const NavItems: React.FC<NavItemProps> = ({ navOpen, setNavOpen }) => {
  return (
    <ul
      className={`lg:gap-8 md:gap-6 gap-4 justify-evenly items-center lg:text-[18px] text-[15px] ${
        navOpen ? "flex flex-col py-4" : "hidden md:flex"
      }`}
    >
      {menuItems.map((item, index) => (
        <li
          className={`hover:text-white hover:bg-black px-2 py-1 ${
            navOpen
              ? "text-white sm:text-[16px] text-sm text-center font-semibold px-8 py-2"
              : ""
          }`}
          key={index}
        >
          <Link
            href={item.path}
            className="font-medium"
            onClick={() => setNavOpen && setNavOpen(false)}
          >
            {item.name}
          </Link>
        </li>
      ))}

      <li className="md:hidden w-full px-10 mb-4">
        <Button
          variants="primary"
          className="bg-black w-full px-4 py-2 rounded-xl color-light font-semibold sm:text-[16px] text-sm hover:cursor-pointer"
          onClick={() => setNavOpen && setNavOpen(false)}
        >
          Book Now
        </Button>
      </li>
    </ul>
  );
};

const Header = () => {
  const [navOpen, setNavOpen] = useState(false);
  return (
    <nav className="mx-0 py-6 bg-[#7c6a46]/15">
      <div className="flex items-center justify-between lg:px-20 md:px-16">
        <div className="px-6">
          <Image src={logo} alt="logo" />
        </div>
        <div className="font-body">
          <NavItems />
        </div>
        <div className="flex items-center gap-4">
          {navOpen ? null : (
            <Button variants="primary" size="medium">
              Book Now
            </Button>
          )}
          {/* Hamburger menu */}
          <div className="md:hidden px-6" onClick={() => setNavOpen(!navOpen)}>
            {navOpen ? (
              <XMarkIcon className="w-8 h-8 color-primary cursor-pointer" />
            ) : (
              <Bars3Icon className="w-8 h-8 color-primary cursor-pointer" />
            )}
          </div>
        </div>

        {/* Menu Items on small screens */}

        {navOpen && (
          <div
            className={`md:hidden absolute bg-[#7c6a46]/95 w-full top-20 z-20 rounded-b-xl`}
          >
            <NavItems navOpen={navOpen} setNavOpen={setNavOpen} />
          </div>
        )}
      </div>
    </nav>
  );
};
export default Header;
